// ABOUTME: Persistent fixed-corner control to reopen privacy preferences at any time.
// ABOUTME: Shows a small pulsing indicator while the microphone is actively recording.

import React from 'react';
import { Cookie } from 'lucide-react';
import { DISCLOSURE } from './consentConfig';

// `behindOverlay`: while the Projectionist's full-bleed reel intro (zIndex 20) is on screen,
// drop this behind it instead of unmounting it — VER-40 requires the control stay reachable
// (the guest just can't see or tap it while the film is playing full-screen).
export function PrivacyLauncher({ onOpen, recording, behindOverlay = false }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={DISCLOSURE.launcherLabel}
      className={`fixed bottom-4 left-4 ${behindOverlay ? 'z-0' : 'z-[120]'} flex items-center gap-2 pl-3 pr-4 py-2.5 bg-white/80 backdrop-blur border border-black/5 hover:bg-black/5 rounded-full transition-colors shadow-sm pointer-events-auto`}
    >
      <Cookie size={16} className="text-neutral-800 shrink-0" />
      <span className="text-[11px] tracking-widest uppercase text-neutral-800 font-medium whitespace-nowrap">
        {DISCLOSURE.launcherLabel}
      </span>
      {recording && (
        <span
          data-testid="recording-indicator"
          aria-label="Recording active"
          className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse ring-2 ring-white"
        />
      )}
    </button>
  );
}
